import NavBar from "../components/Home/NavBar"
import { FilePond, registerPlugin} from 'react-filepond'
/* import 'filepond/dist/filepond.min.css' */
import { useEffect, useState } from "react"
/* import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css' */
import { useParams } from "react-router"

/* registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview) */

const Comprobante = () => {
    const [files, setFiles] = useState([])
    
    const {turnoId} = useParams()


    return (
        <div>
            <NavBar/>
            <FilePond
        files={files}
        onupdatefiles={setFiles}
        maxFiles={1}
        server={`http://localhost:3001/pdf?turnoId=${turnoId}`}
        name="myFile" /* sets the file input name, it's filepond by default */
        labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
      />
        
        </div>
    )
}


export default Comprobante 